import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AddressService } from '@src/app/modules/address/address.service';
import { TransactionService } from '@src/app/modules/transaction/transaction.service';
import { CommonService } from '@src/app/services/common.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { TransactionV2 } from '@src/app/shared/types/transaction.type';
import { getAge, getUtcDate } from '@src/app/shared/utils/common.util';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-transaction-card-v2',
    standalone: true,
    imports: [SharedModule, CommonModule, NzDrawerModule, NzImageModule, NzModalModule],
    providers: [AddressService, TransactionService],
    templateUrl: './transaction-card-v2.component.html',
    styleUrls: ['./transaction-card-v2.component.less'],
})
export class TransactionCardV2Component implements OnChanges {
    @Input() transaction: TransactionV2;
    @Input() isHighlighting = false;
    @Input() gradientCard = false;

    handledTransaction: TransactionV2 & { age: string; utcDate: string };

    get fromImg() {
        return this.commonService.addressIconMap.get(this.transaction?.from_address) || '/assets/imgs/fallback.png';
    }

    get toImg() {
        return this.commonService.addressIconMap.get(this.transaction?.to_address) || '/assets/imgs/fallback.png';
    }

    constructor(public commonService: CommonService) {}

    ngOnChanges(e: SimpleChanges) {
        if (e['transaction'] && e['transaction'].currentValue) {
            const transaction: TransactionV2 = e['transaction'].currentValue;
            this.commonService.setAddressIconMap([transaction.from_address, transaction.to_address]);

            this.handledTransaction = {
                ...transaction,
                age: getAge(transaction.block_timestamp),
                utcDate: getUtcDate(transaction.block_timestamp, 'MMM-DD-YYYY hh:mm:ss A +UTC'),
            } as any;
        }
    }
}
